<template>
    <div class="form-group" :class="{'has-error': error }">
        <label v-if="fieldLabel" :for="name" class="label">{{ fieldLabel }}</label>
        <div class="field-group">
            <vSelect
                :value="value"
                :disabled="disabled"
                :options="options"
                v-bind="$attrs"
                @input="updateValue"
                @change="updateValue"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
            />
            <Transition name="fade">
                <p v-show="error" class="error">{{ error }}</p>
            </Transition>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';

    export default {
        name: 'SelectInput',
        components: {
            vSelect,
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            fieldLabel: {
                type: String,
                required: false,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            options: {
                type: [Array, Object],
                required: true,
            },
            value: {
                type: [Number, Object],
                required: false,
                default: null,
            },
            error: {
                type: String,
                required: false,
                default: null,
            },
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
        },
    };
</script>
